module.exports = __webpack_public_path__ + "assets/img/cursed-shield.56c0fe5c.png";